import * as React from 'react';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const options = [
    { value: 0, label: 'Left to right' },
    { value: 90, label: 'Top to bottom' },
    { value: 180, label: 'Right to left' },
    { value: 270, label: 'Bottom to top' },
];

export const ProcessFlowDirection = () => {
    const [value, setValue] = React.useState<number>(90);
    
    const onChange = (value: number) => {
        setValue(value);
        apiProvider.setProcessFlowDirection({ direction: value });
    };

    React.useEffect(() => {
        const listener = () => {
            const direction = apiProvider.getProcessFlowDirection();
            setValue(direction.direction);
        };

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);


    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value} />
    );
};
